module.exports = __webpack_public_path__ + "img/701_1.9eb4bc7f.jpg";